import React, { useState, useEffect } from 'react';
import { GetList, UpdateEntry, DeleteEntry } from '../../providers/dataProvider';
import userImage from '../../assets/images/userImage.png';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

const Notification = ({ onNotificationRead }) => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState(null);
    const [archivedNotifications, setArchivedNotifications] = useState(null);
    const [activeTab, setActiveTab] = useState('latest');
    const [readMsg, setReadMsg] = useState(null);
    const [readAllMsg, setReadAllMsg] = useState(null);
    const [actionMsg, setActionMsg] = useState(null);

    const cleanupModalBackdrop = () => {
        document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
    };
    const closeNotificationDrawer = () => {
        const $ = window.jQuery || window.$;
        const modal = document.getElementById('notificationRightSideModalPopup');
        if ($ && modal) {
            $(modal).modal('hide');
            $(document).off('focusin.bs.modal');
        } else if (modal) {
            modal.classList.remove('show');
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            modal.removeAttribute('aria-modal');
        }
        cleanupModalBackdrop();
    };

    const fetchNotifications = () => {
        GetList("notificationlatest", {
            pageNumber: 1,
            pageSize: 10,
        }, (res) => {
            setNotifications(res);
        });
    };

    const fetchArchivedNotifications = () => {
        GetList("notificationarchivelist", {
            pageNumber: 1,
            pageSize: 10,
        }, (res) => {
            setArchivedNotifications(res);
        });
    };

    const markAsRead = (id) => {
        UpdateEntry(
            "notificationread",
            { id: id },
            setReadMsg,
            "Marked as read successfully",
            "Failed to mark as read"
        );
    };

    const markAllAsRead = () => {
        UpdateEntry(
            "notificationreadall",
            {},
            setReadAllMsg,
            "All marked as read successfully",
            "Failed to mark all as read"
        );
    };

    const archiveNotification = (id, e) => {
        e.stopPropagation();
        e.preventDefault();
        UpdateEntry(
            "notificationarchive",
            { id },
            setActionMsg,
            "Archived successfully",
            "Failed to archive"
        );
    };

    const deleteNotification = (id, e) => {
        e.stopPropagation();
        e.preventDefault();
        DeleteEntry(
            "notificationdelete",
            { id },
            setActionMsg,
            "Deleted successfully",
            "Failed to delete"
        );
    };

    const handleNotificationClick = (notification) => {
        if (!notification.isRead) {
            markAsRead(notification?.id);

            const updater = (prev) => ({
                ...prev,
                data: {
                    ...prev?.data,
                    payload: prev?.data?.payload?.map(n =>
                        n.id === notification.id ? { ...n, isRead: true } : n
                    )
                }
            });

            if (activeTab === 'archived') {
                setArchivedNotifications(updater);
            } else {
                setNotifications(updater);
            }
        }

        closeNotificationDrawer();

        if (notification?.referenceId) {
            navigate('/job-in-hand', {
                state: {
                    id: notification?.referenceId,
                    initialTab: "Details",
                    initialProductTab: "ProductList"
                }
            });
        }
    };

    const handleViewAll = () => {
        closeNotificationDrawer();
        navigate('/notifications');
    };

    useEffect(() => {
        if (readMsg?.status === 204 || readMsg?.status === 200) {
            fetchNotifications();
            onNotificationRead?.();
        }
    }, [readMsg]);

    useEffect(() => {
        if (readAllMsg?.status === 204 || readAllMsg?.status === 200) {
            fetchNotifications();
            onNotificationRead?.();
        }
    }, [readAllMsg]);

    useEffect(() => {
        if (actionMsg?.status === 204 || actionMsg?.status === 200) {
            fetchNotifications();
            if (activeTab === 'archived') fetchArchivedNotifications();
            onNotificationRead?.();
        } else if (actionMsg?.status === 400) {
            const errorMsg = actionMsg?.successData?.errors?.[0]?.message
                || "Action failed. Please try again.";
            toast.error(errorMsg);
        }
    }, [actionMsg]);

    useEffect(() => {
        fetchNotifications();
    }, []);

    useEffect(() => {
        const $ = window.jQuery || window.$;
        const modal = document.getElementById('notificationRightSideModalPopup');
        if (!$ || !modal) return undefined;

        $(modal).on('hidden.bs.modal', cleanupModalBackdrop);
        return () => $(modal).off('hidden.bs.modal', cleanupModalBackdrop);
    }, []);

    useEffect(() => {
        if (activeTab === 'archived') fetchArchivedNotifications();
    }, [activeTab]);

    const displayList = activeTab === 'latest'
        ? notifications?.data?.payload
        : archivedNotifications?.data?.payload;
    const unreadCount = notifications?.data?.payload?.filter((notification) => !notification.isRead).length || 0;
    const formatNotificationDate = (notification) => {
        const date = notification?.createdAt || notification?.createdDate || notification?.createdOn;
        return date
            ? new Date(date).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
            : null;
    };

    return (
        <>
            <div className="modal fade drawer right-align" id="notificationRightSideModalPopup" tabIndex="-1" role="dialog"
                aria-labelledby="notificationRightSideModalPopupLabel" data-backdrop="false">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="header notification-drawer-header align-items-center">
                            <div className='d-flex justify-content-between'>
                                <h5 id="notificationRightSideModalPopupLabel">Notifications</h5>
                                <button
                                    className="notification-close-btn"
                                    type="button"
                                    data-dismiss="modal"
                                    onClick={closeNotificationDrawer}
                                    aria-label="Close notifications"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body notification-drawer-body">

                            {/* Tabs */}
                            <div className='notification-tabs' role="tablist" aria-label="Notification filters">
                                <button
                                    type="button"
                                    className={activeTab === 'latest' ? 'active' : ''}
                                    onClick={() => setActiveTab('latest')}
                                >
                                    Latest
                                </button>
                                <button
                                    type="button"
                                    className={activeTab === 'archived' ? 'active' : ''}
                                    onClick={() => setActiveTab('archived')}
                                >
                                    Archived
                                </button>
                            </div>

                            {/* Mark all / Clear all - Latest tab only */}
                            {activeTab === 'latest' && (
                                <div className='notification-summary'>
                                    <span className='notification-unread-count'>{unreadCount} Unread Notification{unreadCount !== 1 ? 's' : ''}</span>
                                    <div className='clear-all-area'>
                                        <button type="button" onClick={markAllAsRead}>
                                            Mark all as read
                                        </button>
                                        <button type="button" className="clear-all-btn">Clear all</button>
                                    </div>
                                </div>
                            )}

                            {/* Notification List */}
                            <div className='notification-list'>
                                {!displayList?.length && (
                                    <div className='notification-empty'>
                                        {activeTab === 'archived' ? (
                                            <p>No archived</p>
                                        ) : (
                                            <p>No notifications</p>
                                        )}
                                    </div>
                                )}
                                {displayList?.map((notification) => (
                                    <div className='notification-list-item' key={notification.id}>
                                        <div
                                            className={`${notification.isRead ? 'read-message-area' : 'unread-message-area'} notification-card`}
                                            onClick={() => handleNotificationClick(notification)}
                                        >
                                            <div className='message-content-area'>
                                                <div className='notification-avatar'>
                                                    <img src={userImage} className="user-img" alt="user" />
                                                </div>
                                                <div className='notification-card-content'>
                                                    <div className='notification-card-title-row'>
                                                        <h5>
                                                            {notification.title}
                                                        </h5>
                                                        <span className='notification-card-action'>
                                                            {activeTab === 'latest' && (
                                                                notification.category?.toLowerCase() === 'approval' ? (
                                                                    <i
                                                                        className="far fa-trash-alt"
                                                                        title="Archive"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={(e) => archiveNotification(notification.id, e)}
                                                                    ></i>
                                                                ) : (
                                                                    <i
                                                                        className="far fa-trash-alt"
                                                                        title="Delete"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={(e) => deleteNotification(notification.id, e)}
                                                                    ></i>
                                                                )
                                                            )}
                                                        </span>
                                                    </div>
                                                    {notification.category && <div className='notification-company'>{notification.category}</div>}
                                                    <div className='notification-message'>{notification.message}</div>
                                                    {formatNotificationDate(notification) && <div className='notification-date'>{formatNotificationDate(notification)}</div>}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* View All Notifications */}
                            {/* View All Notifications */}
                            <div className='notification-footer'>
                                <button
                                    type="button"
                                    className='view-all-btn'
                                    onClick={handleViewAll}
                                >
                                    View All Notifications
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;
